const UserConfigRoutes = [
  {
    path: '/configurar-usuarios',
    meta: { title: 'Configurar Usuários' },
    name: 'UserConfig',
    component: () => import('@/views/admin/userconfiguration/userConfiguration.vue'),
  }
]
export default UserConfigRoutes
